const Space = ({ x = 0, y = 0 }: { x?: number; y?: number }) => {
  return (
    <div
      style={{
        width: `${x}px`,
        height: `${y}px`,
      }}
    ></div>
  );
};

export default Space;
